import React, { useEffect, useContext, useState, useCallback, useMemo, useRef } from 'react';
import { RicosContext, RicosViewerContext } from 'ricos-context';
import { G as GALLERY_ITEMS_TYPES, g as getFixedStyles, a as GALLERY_TYPE } from './viewer-loadable2.js';
import { LayoutFixer } from '@wix/pro-gallery-layout-fixer';
import classNames from 'classnames';
import { debounce, isEqual } from 'lodash';
import { GALLERY_CONSTS, ProGallery } from 'pro-gallery';
import imageClientAPI from 'image-client-api/dist/imageClientSDK';
import { normalizeHref, uuid } from 'wix-rich-content-common';
import { migrateOptions } from 'pro-gallery-lib';
import { GalleryOptions_Layout_Type } from 'ricos-schema';
import '@loadable/component';
import 'ricos-types';

var styles = {"gallery_container":"GRP9q","imageTitleContainer":"b37cm","clickableItem":"cNcSv","prerender":"RcsPV","expandContainer":"T7GXF","expandIcon":"nkWzS","itemOverlay":"t0oeF","imageTitle":"F48tI","pointer":"ymciR","fadeIn":"txqkb","changing_background":"m8DPo"};

function _createForOfIteratorHelperLoose$4(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray$4(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$4(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$4(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$4(r, a) : void 0; } }
function _arrayLikeToArray$4(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp$4 = Object.defineProperty;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$4(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$4 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4) {
    for (var _iterator = _createForOfIteratorHelperLoose$4(__getOwnPropSymbols$4(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
    }
  }
  return a;
};
var expand = function expand(props) {
  return /* @__PURE__ */React.createElement("svg", __spreadValues$4({
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */React.createElement("path", {
    d: "M15.071 8.371V4.585l-4.355 4.356a.2.2 0 0 1-.283 0l-.374-.374a.2.2 0 0 1 0-.283l4.356-4.355h-3.786a.2.2 0 0 1-.2-.2V3.2c0-.11.09-.2.2-.2H16v5.371a.2.2 0 0 1-.2.2h-.529a.2.2 0 0 1-.2-.2zm-6.5 6.9v.529a.2.2 0 0 1-.2.2H3v-5.371c0-.11.09-.2.2-.2h.529c.11 0 .2.09.2.2v3.786l4.355-4.356a.2.2 0 0 1 .283 0l.374.374a.2.2 0 0 1 0 .283L4.585 15.07h3.786c.11 0 .2.09.2.2z",
    fill: "#000",
    fillRule: "nonzero"
  }));
};

var ROOT = "galleryViewer";

var WIX_MEDIA_BASE_URL = "https://static.wixstatic.com/";
var WIX_VIDEO_BASE_URL = "https://video.wixstatic.com/";
var getWixFilename = function getWixFilename(url) {
  return url.replace(WIX_MEDIA_BASE_URL, "");
};
var isAbsoluteUrl = function isAbsoluteUrl(url) {
  return url.startsWith("http://") || url.startsWith("https://");
};
var getAbsoluteUrl = function getAbsoluteUrl(url, type) {
  if (isAbsoluteUrl(url)) {
    return url;
  }
  var baseUrl, baseFolder;
  if (type === "image") {
    baseUrl = WIX_MEDIA_BASE_URL;
    baseFolder = "media/";
  } else {
    baseUrl = WIX_VIDEO_BASE_URL;
    baseFolder = "video/";
  }
  var pathWithFolder = url.startsWith(baseFolder) ? url : baseFolder + url;
  return baseUrl + pathWithFolder;
};

var getResizedImageUrl = function getResizedImageUrl(item, originalUrl, resizeMethod, requiredWidth, requiredHeight, sharpParams, focalPoint) {
  originalUrl = originalUrl || "";
  sharpParams = sharpParams || {};
  if (sharpParams.quality > 0) {
    sharpParams.quality = Math.min(90, sharpParams.quality);
  }
  var focalPointObj = {
    x: 50,
    y: 50
  };
  if (focalPoint && focalPoint[0] >= 0 && focalPoint[1] >= 0) {
    focalPointObj.x = Math.round(focalPoint[0] * 100);
    focalPointObj.y = Math.round(focalPoint[1] * 100);
  }
  if (sharpParams.allowUsm === true && sharpParams.usm) {
    sharpParams.usm.usm_a = Math.min(5, Math.max(0, sharpParams.usm.usm_a || 0));
    sharpParams.usm.usm_r = Math.min(128, Math.max(0, sharpParams.usm.usm_r || 0));
    sharpParams.usm.usm_t = Math.min(1, Math.max(0, sharpParams.usm.usm_t || 0));
  } else {
    sharpParams.usm = {
      usm_a: 0,
      usm_r: 0,
      usm_t: 0
    };
  }
  var resizer = function resizer() {};
  if (resizeMethod === "fit") {
    resizer = imageClientAPI.getScaleToFitImageURL;
  } else {
    resizer = imageClientAPI.getScaleToFillImageURL;
  }
  var options = {};
  if (sharpParams.quality > 0) {
    options.quality = sharpParams.quality;
  }
  if (sharpParams.blur > 0) {
    options.filters = {
      blur: sharpParams.blur
    };
  }
  if (focalPointObj) {
    options.focalPoint = focalPointObj;
  }
  if (sharpParams && sharpParams.usm) {
    options.unsharpMask = {
      radius: parseFloat(sharpParams.usm.usm_r),
      amount: parseFloat(sharpParams.usm.usm_a),
      threshold: parseFloat(sharpParams.usm.usm_t)
    };
  }
  if (isAbsoluteUrl(originalUrl)) {
    return originalUrl;
  }
  return resizer(getWixFilename(originalUrl), item.maxWidth, item.maxHeight, requiredWidth, requiredHeight, options);
};
var resizeMediaUrl = function resizeMediaUrl(_ref) {
  var item = _ref.item,
    originalUrl = _ref.originalUrl,
    resizeMethod = _ref.resizeMethod,
    requiredWidth = _ref.requiredWidth,
    requiredHeight = _ref.requiredHeight,
    sharpParams = _ref.sharpParams,
    focalPoint = _ref.focalPoint;
  originalUrl = originalUrl || "";
  sharpParams = sharpParams || {};
  if (originalUrl.indexOf("base64") !== -1) {
    return originalUrl;
  }
  requiredWidth = Math.ceil(requiredWidth);
  requiredHeight = Math.ceil(requiredHeight);
  if (resizeMethod === GALLERY_ITEMS_TYPES.VIDEO) {
    return getAbsoluteUrl(originalUrl, GALLERY_ITEMS_TYPES.VIDEO);
  } else if (requiredWidth >= item.maxWidth && requiredHeight >= item.maxHeight) {
    var url = item.dto.metaData.type === GALLERY_ITEMS_TYPES.VIDEO ? originalUrl : item.url;
    return getAbsoluteUrl(url, GALLERY_ITEMS_TYPES.IMAGE);
  } else {
    return getResizedImageUrl(item, originalUrl, resizeMethod, requiredWidth, requiredHeight, sharpParams, focalPoint);
  }
};

var isValidGalleryId = function isValidGalleryId(nodeId) {
  return /^[-_\w]*$/.test(nodeId);
};

var useIsPrerender = function useIsPrerender() {
  var _React$useState = React.useState(true),
    isPrerender = _React$useState[0],
    setIsPrerender = _React$useState[1];
  React.useEffect(function () {
    setIsPrerender(false);
  }, []);
  return isPrerender;
};

var useResizeObserver = function useResizeObserver(_ref) {
  var callback = _ref.callback,
    element = _ref.element;
  useEffect(function () {
    if (!(window == null ? void 0 : window.ResizeObserver)) {
      return;
    }
    var observer = new ResizeObserver(callback);
    if (element) {
      observer.observe(element);
    }
    return function () {
      observer.disconnect();
    };
  }, [element, callback]);
};

var RESIZE_OBSERVER_DELAY = 100;
var defaultContainers = {
  desktop: {
    width: 980,
    height: 500
  },
  mobile: {
    width: 320,
    height: 500
  }
};
var useHeight = function useHeight(props) {
  var _React$useState = React.useState(false),
    isMeasuredContainer = _React$useState[0],
    setIsMeasuredContainer = _React$useState[1];
  var isPrerender = useIsPrerender();
  var options = props.options,
    layout = props.layout;
  var responsive = options.responsive;
  var mobile = defaultContainers.mobile,
    desktop = defaultContainers.desktop;
  var _useContext = useContext(RicosContext),
    isMobile = _useContext.isMobile,
    jsdomMode = _useContext.jsdomMode;
  var containerWidthResponsive = isMobile ? mobile.width : desktop.width;
  var containerHeightResponsive = isMobile ? mobile.height : desktop.height;
  var defaultContainer = {
    isDefaultContainer: true,
    width: containerWidthResponsive,
    height: containerHeightResponsive
  };
  var _useState = useState(defaultContainer),
    container = _useState[0],
    setContainer = _useState[1];
  var _useState2 = useState(container.height),
    height = _useState2[0],
    setHeight = _useState2[1];
  var _useState3 = useState(null),
    containerRef = _useState3[0],
    setContainerRef = _useState3[1];
  React.useEffect(function () {
    if (isMeasuredContainer) {
      setIsMeasuredContainer(false);
      setContainer(defaultContainer);
    }
  }, [layout]);
  var resizeGallery = useCallback(function () {
    setContainer(function (prevState) {
      if ((containerRef == null ? void 0 : containerRef.clientHeight) && prevState.height && Math.abs(prevState.height - (containerRef == null ? void 0 : containerRef.clientHeight)) <= 1 && Math.abs(prevState.width - (containerRef == null ? void 0 : containerRef.clientWidth)) <= 1) {
        return prevState;
      }
      return {
        width: containerRef == null ? void 0 : containerRef.clientWidth,
        height: containerRef == null ? void 0 : containerRef.clientHeight
      };
    });
    setIsMeasuredContainer(true);
  }, [containerRef, setIsMeasuredContainer]);
  var resizeObserverCallback = useMemo(function () {
    return debounce(resizeGallery, RESIZE_OBSERVER_DELAY);
  }, [resizeGallery]);
  useResizeObserver({
    element: containerRef,
    callback: resizeObserverCallback
  });
  var heightStyle = responsive ? {} : {
    height: height
  };
  var setHeightImp = function setHeightImp(newHeight) {
    setHeight(newHeight);
  };
  var containerClassName = isPrerender ? styles.prerender : "";
  return {
    isMeasuredContainer: jsdomMode ? !isPrerender : isMeasuredContainer,
    setHeight: setHeightImp,
    container: container,
    setContainerRef: setContainerRef,
    containerStyle: heightStyle,
    containerClassName: containerClassName
  };
};

function _createForOfIteratorHelperLoose$3(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray$3(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$3(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$3(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$3(r, a) : void 0; } }
function _arrayLikeToArray$3(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp$3 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$3(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3) {
    for (var _iterator = _createForOfIteratorHelperLoose$3(__getOwnPropSymbols$3(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps$2 = function __spreadProps(a, b) {
  return __defProps$2(a, __getOwnPropDescs$2(b));
};
function convertToGalleryItems(items, relValue, anchorTarget) {
  return items.map(function (item, index) {
    var _a, _b, _c, _d;
    var image = item.image,
      video = item.video,
      title = item.title,
      altText = item.altText;
    var media = (image == null ? void 0 : image.media) || (video == null ? void 0 : video.media);
    var mediaUrl = ((_a = media == null ? void 0 : media.src) == null ? void 0 : _a.url) || ((_b = media == null ? void 0 : media.src) == null ? void 0 : _b.id) || "";
    var width = (media == null ? void 0 : media.width) || 0;
    var height = (media == null ? void 0 : media.height) || 0;
    var convertedData = {
      mediaUrl: mediaUrl,
      url: mediaUrl,
      metaData: {
        type: image ? "image" : "video",
        height: height,
        width: width,
        title: title,
        alt: altText
      }
    };
    if (video) {
      convertedData.metaData.link = {
        target: "_blank",
        rel: "noopener",
        url: (_c = normalizeHref(mediaUrl)) != null ? _c : ""
      };
      var _ref = video.thumbnail || {},
        src = _ref.src,
        thumbnailWidth = _ref.width,
        thumbnailHeight = _ref.height;
      if (src == null ? void 0 : src.url) {
        convertedData.metaData.poster = {
          url: src.url,
          width: thumbnailWidth || width,
          height: thumbnailHeight || height
        };
      }
    }
    if (image == null ? void 0 : image.link) {
      var _image$link = image.link,
        _image$link$url = _image$link.url,
        linkUrl = _image$link$url === void 0 ? "" : _image$link$url,
        linkTarget = _image$link.target,
        linkRel = _image$link.rel;
      var target = linkTarget && "_" + linkTarget.toLowerCase() || anchorTarget || "_self";
      var url = (_d = normalizeHref(linkUrl)) != null ? _d : "";
      var rel = relValue || "noopener";
      if (linkRel) {
        rel = "noopener";
        linkRel.nofollow && (rel += " nofollow");
        linkRel.sponsored && (rel += " sponsored");
        linkRel.ugc && (rel += " ugc");
        (linkRel.noreferrer || linkRel.noreferrer === void 0) && (rel += " noreferrer");
      }
      convertedData.metaData.link = {
        type: "wix",
        target: target,
        data: {
          type: "ExternalLink",
          target: target,
          rel: rel,
          url: url
        }
      };
      convertedData.directLink = {
        url: url,
        target: target,
        rel: rel
      };
    }
    return __spreadProps$2(__spreadValues$3({}, convertedData), {
      // uuid is used to guarentee there are no 2 gallery items on the DOM with the same ID (on different galleries) due to a pro gallery issues with videos - breaks the video controls behavoiur.
      itemId: uuid() + "_" + index.toString(),
      hash: mediaUrl + "_" + index.toString()
    });
  });
}
function useItems(items, relValue, anchorTarget) {
  var galleryItems = useMemo(function () {
    return convertToGalleryItems(items, relValue, anchorTarget);
  }, [items]);
  return galleryItems;
}

var _GALLERY_LAYOUT_TO_NU, _NUMBER_TO_GALLERY_LA, _SCROLL_DIRECTION_TO_;
var isHorizontalLayout = function isHorizontalLayout(_ref) {
  var layout = _ref.layout;
  return layout && ([GalleryOptions_Layout_Type.THUMBNAIL, GalleryOptions_Layout_Type.SLIDER, GalleryOptions_Layout_Type.SLIDESHOW, GalleryOptions_Layout_Type.COLUMN, GalleryOptions_Layout_Type.FULLSIZE].includes(layout.type) || layout.horizontalScroll);
};
var sampleItems = [1, 2, 3].map(function (i) {
  return {
    metaData: {
      height: 10,
      width: 10
    },
    itemId: "sampleItem-" + i,
    mediaUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAAA1JREFUCB1jePv27X8ACVkDxyMHIvwAAAAASUVORK5CYII="
    //eslint-disable-line
  };
});
var GALLERY_LAYOUT_TO_NUMBER = (_GALLERY_LAYOUT_TO_NU = {}, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.GRID] = GALLERY_CONSTS.layoutParams_structure_galleryLayout.GRID, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.MASONRY] = GALLERY_CONSTS.layoutParams_structure_galleryLayout.MASONRY, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.COLLAGE] = GALLERY_CONSTS.layoutParams_structure_galleryLayout.COLLAGE, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.THUMBNAIL] = GALLERY_CONSTS.layoutParams_structure_galleryLayout.THUMBNAIL, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.SLIDER] = GALLERY_CONSTS.layoutParams_structure_galleryLayout.SLIDER, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.SLIDESHOW] = GALLERY_CONSTS.layoutParams_structure_galleryLayout.SLIDESHOW, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.PANORAMA] = GALLERY_CONSTS.layoutParams_structure_galleryLayout.PANORAMA, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.COLUMN] = GALLERY_CONSTS.layoutParams_structure_galleryLayout.COLUMN, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.MAGIC] = GALLERY_CONSTS.layoutParams_structure_galleryLayout.MAGIC, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.FULLSIZE] = GALLERY_CONSTS.layoutParams_structure_galleryLayout.FULLSIZE, _GALLERY_LAYOUT_TO_NU);
(_NUMBER_TO_GALLERY_LA = {}, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layoutParams_structure_galleryLayout.COLLAGE] = GalleryOptions_Layout_Type.COLLAGE, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layoutParams_structure_galleryLayout.MASONRY] = GalleryOptions_Layout_Type.MASONRY, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layoutParams_structure_galleryLayout.GRID] = GalleryOptions_Layout_Type.GRID, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layoutParams_structure_galleryLayout.THUMBNAIL] = GalleryOptions_Layout_Type.THUMBNAIL, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layoutParams_structure_galleryLayout.SLIDER] = GalleryOptions_Layout_Type.SLIDER, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layoutParams_structure_galleryLayout.SLIDESHOW] = GalleryOptions_Layout_Type.SLIDESHOW, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layoutParams_structure_galleryLayout.PANORAMA] = GalleryOptions_Layout_Type.PANORAMA, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layoutParams_structure_galleryLayout.COLUMN] = GalleryOptions_Layout_Type.COLUMN, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layoutParams_structure_galleryLayout.MAGIC] = GalleryOptions_Layout_Type.MAGIC, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layoutParams_structure_galleryLayout.FULLSIZE] = GalleryOptions_Layout_Type.FULLSIZE, _NUMBER_TO_GALLERY_LA);
var SCROLL_DIRECTION_TO_NUMBER = (_SCROLL_DIRECTION_TO_ = {}, _SCROLL_DIRECTION_TO_[GALLERY_CONSTS.layoutParams_structure_scrollDirection.VERTICAL] = 0, _SCROLL_DIRECTION_TO_[GALLERY_CONSTS.layoutParams_structure_scrollDirection.HORIZONTAL] = 1, _SCROLL_DIRECTION_TO_);

function _createForOfIteratorHelperLoose$2(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray$2(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$2(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$2(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$2(r, a) : void 0; } }
function _arrayLikeToArray$2(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp$2 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$2(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2) {
    for (var _iterator = _createForOfIteratorHelperLoose$2(__getOwnPropSymbols$2(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps$1 = function __spreadProps(a, b) {
  return __defProps$1(a, __getOwnPropDescs$1(b));
};
var convertToGalleryOptions = function convertToGalleryOptions(options) {
  var galleryOptions = {};
  var layout = options.layout,
    thumbnails = options.thumbnails,
    item = options.item;
  if (layout) {
    var type = layout.type,
      horizontalScroll = layout.horizontalScroll,
      orientation = layout.orientation,
      numberOfColumns = layout.numberOfColumns,
      mobileNumberOfColumns = layout.mobileNumberOfColumns;
    type && (galleryOptions.galleryLayout = parseInt(GALLERY_LAYOUT_TO_NUMBER[type]));
    horizontalScroll && (galleryOptions.scrollDirection = SCROLL_DIRECTION_TO_NUMBER[GALLERY_CONSTS.layoutParams_structure_scrollDirection.HORIZONTAL]);
    orientation && (galleryOptions.isVertical = orientation === "COLUMNS");
    typeof numberOfColumns === "number" && (galleryOptions.numberOfImagesPerRow = numberOfColumns);
    typeof mobileNumberOfColumns === "number" && (galleryOptions.m_numberOfImagesPerRow = mobileNumberOfColumns);
  }
  if (item) {
    var targetSize = item.targetSize,
      ratio = item.ratio,
      crop = item.crop,
      spacing = item.spacing;
    typeof targetSize === "number" && (galleryOptions.gallerySizePx = targetSize);
    typeof ratio === "number" && (galleryOptions.cubeRatio = ratio);
    crop && (galleryOptions.cubeType = crop.toLowerCase());
    typeof spacing === "number" && (galleryOptions.imageMargin = spacing);
  }
  if (thumbnails) {
    var placement = thumbnails.placement,
      _spacing = thumbnails.spacing;
    placement && (galleryOptions.galleryThumbnailsAlignment = placement.toLowerCase());
    typeof _spacing === "number" && (galleryOptions.thumbnailSpacings = _spacing / 2);
  }
  return galleryOptions;
};
function useOptions(options, disableDownload) {
  var _useContext = useContext(RicosContext),
    isMobile = _useContext.isMobile;
  var galleryOptions = useMemo(function () {
    var _a;
    var isHorizontal = isHorizontalLayout(options);
    var calculatedOptions = __spreadValues$2(__spreadProps$1(__spreadValues$2({}, getFixedStyles(((_a = options.layout) == null ? void 0 : _a.type) || GalleryOptions_Layout_Type.GRID)), {
      allowContextMenu: !disableDownload,
      showArrows: isHorizontal,
      responsive: true
    }), convertToGalleryOptions(options));
    if (isMobile) {
      if (calculatedOptions.m_numberOfImagesPerRow) {
        calculatedOptions.numberOfImagesPerRow = calculatedOptions.m_numberOfImagesPerRow;
      }
      if (isHorizontal) {
        calculatedOptions.arrowsSize = 20;
        !calculatedOptions.imageMargin && (calculatedOptions.imageMargin = 0);
        if (calculatedOptions.galleryLayout === GALLERY_LAYOUT_TO_NUMBER[GalleryOptions_Layout_Type.THUMBNAIL]) {
          calculatedOptions.thumbnailSize = 90;
        }
      }
    }
    return {
      options: migrateOptions(calculatedOptions),
      calculatedOptions: calculatedOptions
    };
  }, [options]);
  return galleryOptions;
}

function _createForOfIteratorHelperLoose$1(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$1(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0; } }
function _arrayLikeToArray$1(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1) {
    for (var _iterator = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest$1 = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1) {
    for (var _iterator2 = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop)) target[prop] = source[prop];
    }
  }
  return target;
};
var GALLERY_EVENTS = GALLERY_CONSTS.events;
var GalleryViewer = /*#__PURE__*/React.memo(function (_ref) {
  var _classNames;
  var componentData = _ref.componentData,
    nodeId = _ref.nodeId,
    settings = _ref.settings,
    relValue = _ref.relValue,
    anchorTarget = _ref.anchorTarget,
    seoMode = _ref.seoMode,
    helpers = _ref.helpers,
    itemOverlayElement = _ref.itemOverlayElement;
  var _b;
  var _a = settings,
    scrollingElement = _a.scrollingElement,
    gallerySettings = __objRest$1(_a, ["scrollingElement"]);
  var galleryRef = useRef(null);
  var _ref2 = componentData || {},
    ricosItems = _ref2.items,
    ricosOptions = _ref2.options,
    disableExpand = _ref2.disableExpand,
    disableDownload = _ref2.disableDownload;
  var _useContext = useContext(RicosContext),
    tabIndex = _useContext.tabIndex;
  var items = useItems(ricosItems || [], relValue, anchorTarget);
  var _useOptions = useOptions(ricosOptions || {}, disableDownload),
    options = _useOptions.options,
    calculatedOptions = _useOptions.calculatedOptions;
  var galleryOptions = __spreadProps(__spreadValues$1({}, options), {
    behaviourParams_item_overlay_backgroundColor: "transparent"
  });
  var layout = ((_b = ricosOptions == null ? void 0 : ricosOptions.layout) == null ? void 0 : _b.type) || "";
  var _useHeight = useHeight({
      options: galleryOptions,
      layout: layout
    }),
    setHeight = _useHeight.setHeight,
    container = _useHeight.container,
    setContainerRef = _useHeight.setContainerRef,
    containerStyle = _useHeight.containerStyle,
    containerClassName = _useHeight.containerClassName,
    isMeasuredContainer = _useHeight.isMeasuredContainer;
  var handleContextMenu = function handleContextMenu(e) {
    return disableDownload && e.preventDefault();
  };
  var viewMode = seoMode ? GALLERY_CONSTS.viewMode.SEO : GALLERY_CONSTS.viewMode.SITE;
  var hasExpand = !disableExpand && !settings.disableExpand && settings.onExpand && ricosItems.length > 0;
  var handleExpand = function handleExpand(itemId) {
    var _a2;
    (_a2 = helpers == null ? void 0 : helpers.onViewerAction) == null ? void 0 : _a2.call(helpers, GALLERY_TYPE, "Click", "expand_gallery");
    hasExpand && settings.onExpand(nodeId, itemId);
  };
  var handleGalleryEvents = function handleGalleryEvents(name, data) {
    switch (name) {
      case GALLERY_EVENTS.GALLERY_CHANGE:
        if (galleryRef.current) {
          if (!isHorizontalLayout(options)) {
            galleryRef.current.style.height = data.layoutHeight + "px";
          } else {
            galleryRef.current.style.height = "auto";
          }
        }
        break;
      case GALLERY_EVENTS.ITEM_ACTION_TRIGGERED:
        data.type !== "video" && !data.linkData.url && !disableExpand && handleExpand(data.idx);
        break;
    }
  };
  var customHoverRenderer = function customHoverRenderer(itemProps) {
    return /* @__PURE__ */React.createElement("div", {
      className: styles.itemOverlay
    }, itemProps.title && /* @__PURE__ */React.createElement("div", {
      className: styles.imageTitleContainer
    }, /* @__PURE__ */React.createElement("div", {
      className: styles.imageTitle
    }, itemProps.title)), itemOverlayElement == null ? void 0 : itemOverlayElement(itemProps));
  };
  var isPrerenderMode = !isMeasuredContainer;
  var validNodeId = useMemo(function () {
    return isValidGalleryId(nodeId) ? nodeId : "";
  }, [nodeId]);
  var customImageRenderer = function customImageRenderer(itemProps) {
    return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement("img", __spreadProps(__spreadValues$1({
      alt: itemProps.alt
    }, itemProps), {
      tabIndex: tabIndex
    })), hasExpand && /* @__PURE__ */React.createElement("div", {
      className: styles.expandContainer,
      "data-hook": "expand-container"
    }, /* @__PURE__ */React.createElement(expand, {
      className: styles.expandIcon,
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        handleExpand(itemProps["data-idx"]);
      }
    })));
  };
  return /* @__PURE__ */React.createElement("div", {
    ref: setContainerRef,
    className: classNames(styles.gallery_container, containerClassName, (_classNames = {}, _classNames[styles.clickableItem] = hasExpand, _classNames)),
    style: containerStyle,
    "data-hook": ROOT,
    role: "none",
    onContextMenu: handleContextMenu
  }, /* @__PURE__ */React.createElement(ProGallery, {
    id: nodeId,
    items: items.length > 0 ? items : sampleItems,
    options: galleryOptions,
    container: container,
    settings: __spreadProps(__spreadValues$1({}, gallerySettings), {
      isAccessible: true
    }),
    scrollingElement: typeof scrollingElement === "function" ? scrollingElement() : scrollingElement,
    eventsListener: handleGalleryEvents,
    createMediaUrl: resizeMediaUrl,
    viewMode: viewMode,
    customComponents: {
      customHoverRenderer: customHoverRenderer,
      customImageRenderer: customImageRenderer
    },
    totalItemsCount: items.length || sampleItems.length,
    setLayoutHeightImp: setHeight,
    isPrerenderMode: isPrerenderMode
  }), validNodeId ? /* @__PURE__ */React.createElement(LayoutFixer, {
    id: validNodeId,
    isPrerenderMode: isPrerenderMode,
    items: items,
    options: calculatedOptions
  }) : null);
}, function (prevProps, nextProps) {
  return isEqual(filterOutNonDisplayedProps(prevProps), filterOutNonDisplayedProps(nextProps));
});
function filterOutNonDisplayedProps(props) {
  return __spreadProps(__spreadValues$1({}, props), {
    componentData: __spreadProps(__spreadValues$1({}, props.componentData), {
      items: props.componentData.items.map(function (_a) {
        var _b = _a;
          _b.altText;
          _b.title;
          var image = _b.image,
          rest = __objRest$1(_b, ["altText", "title", "image"]);
        if (!image) {
          return rest;
        }
        var _a2 = image;
          _a2.link;
          var imageRest = __objRest$1(_a2, ["link"]);
        return __spreadProps(__spreadValues$1({}, rest), {
          image: imageRest
        });
      })
    })
  });
}

function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }
  return target;
};
var Gallery = function Gallery(_ref) {
  var node = _ref.node,
    nodeIndex = _ref.nodeIndex,
    NodeViewContainer = _ref.NodeViewContainer;
  var _useContext = useContext(RicosViewerContext),
    relValue = _useContext.relValue,
    anchorTarget = _useContext.anchorTarget,
    config = _useContext.config,
    seoMode = _useContext.seoMode,
    helpers = _useContext.helpers;
  return /* @__PURE__ */React.createElement(NodeViewContainer, {
    node: node,
    nodeIndex: nodeIndex
  }, /* @__PURE__ */React.createElement(GalleryViewer, {
    componentData: node.galleryData || {},
    nodeId: node.id,
    settings: config[GALLERY_TYPE],
    relValue: relValue,
    anchorTarget: anchorTarget,
    seoMode: seoMode,
    helpers: helpers
  }));
};
var GalleryRenderer = function GalleryRenderer(_a) {
  var _b = _a,
    node = _b.node,
    props = __objRest(_b, ["node"]);
  return /* @__PURE__ */React.createElement(Gallery, __spreadValues({
    key: node.id,
    node: node
  }, props));
};

export { GalleryRenderer as default };

import 'wix-rich-content-plugin-gallery/dist/loadable/viewer/es/styles.viewer.min.global.css'